import { createFileRoute } from '@tanstack/react-router'
import { rentalListSearchSchema, RentalOrderList } from '@/features/order/index.ts'
import { usePersistedListQuery } from '@/hooks/use-persisted-list-query.ts'
import { createListQueryPersistence } from '@/utils/list-query-persistence.ts'

const listQuery = createListQueryPersistence('super-mega:orders:rentals:list-query', rentalListSearchSchema)

export const Route = createFileRoute('/_authenticated/orders/rentals/')({
  beforeLoad: (options) => {
    listQuery.restore(options)
  },
  validateSearch: listQuery.validateSearch,
  component: RentalsPage,
  head: () => ({ meta: [{ title: '租赁订单 · Super Mega' }] })
})
function RentalsPage() {
  const { currentSession } = Route.useRouteContext()
  const { search, navigateSearch } = usePersistedListQuery({
    persistence: listQuery,
    raw: Route.useSearch(),
    accountId: currentSession.id,
    navigate: Route.useNavigate()
  })
  return <RentalOrderList search={search} navigateSearch={navigateSearch} currentSession={currentSession} />
}
